import {
    apiRequest,
    AwardPeriodAwardList as list,
    AwardExclude as inactive
} from "../../../../../services/adapters/kepegawaian/penghargaanService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", list, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", inactive, {
            body: query
        }, true)
    }

}

export default DataTableRepository